import React, { FC } from 'react';
import { Badge } from 'antd';
import { Link } from 'react-router-dom';
import { usePath } from 'shared/hooks';
import { ViewerNotificationsResponse } from 'app/services/edpApiV1/viewer';
import { IndicatorKeys, MenuKeyLink } from '../types';
import style from './index.module.scss';

type TRenderItemProps = {
  notification?: IndicatorKeys;
  notificationsData?: ViewerNotificationsResponse;
  title: React.ReactNode;
  path?: MenuKeyLink;
};

const RenderItem: FC<TRenderItemProps> = ({ notification, notificationsData, title, path }) => {
  const mainPath = usePath(1);

  return (
    <div className={style.menuItem}>
      {<span>{title}</span>}
      {notification && path && (
        <Link to={path}>
          <Badge
            count={notificationsData?.sidebar[notification]}
            overflowCount={99}
            className={mainPath === path?.replace('/', '') ? style.active : ''}
          />
        </Link>
      )}
    </div>
  );
};

export default RenderItem;
